import type { ReactNode } from "react";

// A "?" marker that reveals side information on hover or keyboard focus.
export function HelpTip({ label, children }: { label: string; children: ReactNode }) {
  return <span className="gc-help">
    <button type="button" className="gc-help-mark" aria-label={label}>?</button>
    <span className="gc-help-pop" role="tooltip">{children}</span>
  </span>;
}
